import React from "react";
import { Clock } from "lucide-react";

// Step 7.6 (2026-02-15) — Session-expiry warning toast.
//
// Non-blocking bottom-right card that appears when the user has been
// idle for `idleMinutes - 60s`. Shows a live countdown and a "Stay
// signed in" button. Activity anywhere on the page ALSO dismisses it
// (see useSessionIdle) so the user doesn't need to explicitly click.
//
// Design notes:
//   * Coral top-border marks it as a warning without blocking the view.
//   * `pointer-events-none` on the outer wrapper except on the card
//     itself — so clicks pass through the toast area to the app.

const fmtLeft = (s) => (s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : `${s}s`);

export default function SessionExpiringToast({
  secondsLeft,
  onStay,
  title = "You'll be signed out in",
  subtitle = "Move your mouse or click below to stay signed in.",
  buttonLabel = "Stay signed in",
  testIdPrefix = "session-expiring",
}) {
  if (secondsLeft == null) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-40 pointer-events-none"
      data-testid={`${testIdPrefix}-toast-wrap`}
    >
      <div
        className="bg-white border border-rule shadow-2xl px-4 py-3 flex items-center gap-3 rounded-[8px] pointer-events-auto"
        style={{ borderTop: "3px solid #EA6A47", minWidth: 340 }}
        data-testid={`${testIdPrefix}-toast`}
      >
        <div className="text-coral shrink-0">
          <Clock size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[12.5px] font-semibold text-navy leading-tight">
            {title}{" "}
            <span className="font-mono tabular-nums" data-testid={`${testIdPrefix}-countdown`}>
              {fmtLeft(secondsLeft)}
            </span>
          </div>
          <div className="text-[10.5px] text-slate mt-0.5 leading-tight">
            {subtitle}
          </div>
        </div>
        <button
          type="button"
          onClick={onStay}
          className="text-[12px] font-semibold text-white px-3 py-1.5 rounded-[3px] shrink-0 transition-colors"
          style={{ backgroundColor: "#1C4E80", cursor: "pointer" }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#12406B"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#1C4E80"; }}
          data-testid={`${testIdPrefix}-stay-btn`}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
